module.exports = __webpack_public_path__ + "img/classic_rental40_1.d1b4fd1e.jpg";